import styled from "styled-components";

const SupportHomeStyles = styled.div`
  a.link::before {
    content: url('/icons/support-link-icon.svg');
    position: relative;
    top: 4px;
    margin-right: 12px;
  }

  .hero-title-container {
    height: 56px;
    margin: auto;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(18, 23, 36, 0.2);

    ${props => props.theme.media.lg} {
      height: auto;
      border-bottom: 0px;
      justify-content: center;
    }

    .hero-title {
      margin-left: 16px;
      font-weight: 500;
      font-size: 18px;
      line-height: 28px;
      letter-spacing: 0.01em;
      color: rgba(18, 23, 36, 0.91);

      ${props => props.theme.media.lg} {
        text-align: center;
        font-weight: 400;
        font-size: 36px;
        line-height: 48px;
        margin-top: 40px;
        margin-bottom: 32px;
      }
    }
  }

  .hero-container {
    position: relative;
    width: 100%;

    ${props => props.theme.media.lg} {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .hero-image {
      min-height: 295px;
      object-fit: cover;
      object-position: 70%;

    }

    .input-container {
      position: absolute;
      bottom: 18px;
      left: 0;
      width: 100%;
      z-index: 2;
    }
  }

  .content-wrapper {
    padding: 16px;

    ${props => props.theme.media.lg} {
      padding: 33px 33%;
    }
    .popular-title-container {
      margin-bottom: 12px;

      img {
        margin-right: 5px;
      }

      .popular-title {
        display: inline;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: rgba(18, 23, 36, 0.65);
        letter-spacing: 0.01em;
      }
    }

    .popular-links-container {
      .link-wrapper {
        margin-bottom: 12px;

        .link {
          color: #1776B6;
        }
      }
    }

    .all-sections-container {
      .all-sections-title {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.01em;
        color: rgba(18, 23, 36, 0.65);
        margin-bottom: 16px;
      }

      .icons-container {
        ${props => props.theme.media.lg} {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-gap: 1rem;
        }
      }

      .icons-container {
        ${props => props.theme.media.lg} {
          margin-bottom: 40px;
        }
        .support-icon:last-child {
          grid-column: span 2;
      }
    }
  }

`;

export default SupportHomeStyles;